import React from "react";
import { LoginScreen } from "ui/templates";

function Login() {
  return <LoginScreen />;
}

export default Login;
